export { getDefaultTranslations }

const pl = {
  'LOADER_TITLE': 'Szybki kontakt',
  'LOADER_FAB_MENU': {
    'CALL': 'Zadzwoń do nas',
    'AUDIO': 'Zadzwoń do nas',
    'VIDEO': 'Połączenie wideo',
    'CHAT': 'Napisz na chat',
    'MAIL': 'Wyślij wiadomość'
  }
};

const en = {
  'LOADER_TITLE': 'Quick contact',
  'LOADER_FAB_MENU': {
    'CALL': 'Call us',
    'AUDIO': 'Call us',
    'VIDEO': 'Video call',
    'CHAT': 'Chat with us',
    'MAIL': 'Send us a message'
  }
};

function getDefaultTranslations(key) {
  return key === 'pl' ? pl : en;
}
